import UserPage from './user'

export default [
  {
    Component: UserPage,
    title: 'User',
    path: '/user'
  }
]
